// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2GdQa","row":"styles_row__22raI"};